import { Firebase } from 'types/firebase';

export const vatMap: Record<Firebase.CountryCodes, number[]> = {
  DK: [0, 25],
  ES: [0, 4, 10, 21],
  FO: [0, 25],
  SE: [0, 6, 12, 25],
  NO: [0, 6, 11.1, 12, 15, 25],
};
